import React, { Component } from "react";
import Select, { createFilter } from "react-select";
import classNames from "classnames";
import PageHeader from "../../../components/pageHeader/pageHeader";
import BreadcrumbBar from "../../../components/breadcrumbBar";
import MQSGUtil from "../../../components/mqsgUtil";
// import WarrantCalculator from "../warrantcalculator/calculator";
import AdvertBox from "../../../components/advert/advert";
import ReactTooltip from "react-tooltip";
import "./livematrix.css";
import LiveIndexFuture from "../../../components/liveindexfuture/liveindexfuture";
import "../warrantterm/term.css";

import { Link } from "react-router-dom";

import {
  IndtableShow,
  LivematrixLogic,
  LiveMatrixTodayTable,
  TermsChart,
  WarrantHedget,
  WrCalculatorBox
} from "../../../components/WarrantTools";

// LiveMatrix 标签页常量定义
const LIVE_MATRIX_TABS = {
  HISTORICAL_PERFORMANCE: 1,
  WARRANT_CALCULATOR: 2,
  LIVE_MATRIX: 3,
  WARRANT_TERMS: 4,
  EXPOSURE_SIMULATOR: 5,
};

import LastView from "../../../components/lastView";

export default class LiveMatrix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      symbols: null,
      livematrixdata: null,
      isLoading: true,
      tabNum: LIVE_MATRIX_TABS.LIVE_MATRIX, // 默认显示 Live Matrix 标签页
      period: 'Y',
      chartData: [],
      isLoadingChart: false,
      underlying: [],
      lastviewrics: null,
      date1: '',
      latestNewTitle: "",
      latestNewUnderlying: "",
      showHSILiveIndex: false,
      showNKYLiveIndex: false,
      showHSTECHLiveIndex: false,
      showSIMSCILiveIndex: false,
      showSP500LiveIndex: false,
      displayMorningMarketBuzz: false,
      title: '',
      needModifyBID: false,
      messageList:[],
      // Live index data
      hsiData: null,
      hstechData: null,
      nkyData: null,
      simsciData: null,
      sp500Data: null
    };
    this.page = "livematrix";
    this.logic = null;
    this.ticker = null;
    this.warrantRef = null;
    this.setWarrantRef = this.setWarrantRef.bind(this);
    this.initRedirect(props);
  }

  setWarrantRef(ref) {
    this.warrantRef = ref;
  }
  onFetchUnderlyingSymbol() {
    const url = MQSGUtil.getAPIBasePath() + "/SymbolsJSON?type=s";
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          let fianlresult =  MQSGUtil.filterDataSymbolsJSON(result);
          this.setState({ underlying: fianlresult });
        },
        (error) => {
          this.setState({ underlying: [] });
        }
      );
  }
  onUnderlyingChange(option) {
    const url = MQSGUtil.getAPIBasePath() + "/SymbolsJSON?ric=" + option.ric;
    if (this.warrantRef && this.warrantRef.warrant) {
      this.warrantRef.warrant.onMenuOpen()
    }
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ symbols: result });
        },
      );
  }
  onMenuOpen() {
    const warrantComponent = this.warrantRef;
    if (warrantComponent && warrantComponent.closeDropdown) {
      warrantComponent.closeDropdown();
    }
  }
  onPeriodChange(period) {
    if (this.state.livematrixdata !== null) {
      const ric = this.state.selected?.value;
      const underlyingric = this.state.livematrixdata?.ric_data?.underlying_ric;
      if (underlyingric !== null) {
        // const selectedNew = { ...this.state.selected };
        this.setState({ period: period, chartdata: null });
        this.onFetchChartData(underlyingric, ric, period);
      }
    }
  }
  onFetchChartData(underlyingRic, ric, period = "Y") {
    if (MQSGUtil.isUsingStaticData("Warrantterms")) {
      setTimeout(() => {
        this.onFetchStaticChartData(underlyingRic, ric, period);
      }, 100); // pretend fetch
      return;
    }
    const isLoadingChart = false;
    const ricString = underlyingRic + ";" + ric;
    let chartdata = null;
    const url = MQSGUtil.getAPIBasePath() + "/HistoricalPerformanceChartJSON?TYPE=JSON&RIC=" + ricString + "&PERIODICITY=" + period + "&d=" + Date.now();
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          chartdata = result;
          const arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
          let needModifyBID = false;
          if (typeof ricString === 'string' && ricString.trim()) {
              for (const item of arry) {
                  if (item.trim() === ricString.trim() || ricString.includes(item.trim()) ) { 
                      needModifyBID = true;
                      break;
                  }
              }
          }
         
          if (!needModifyBID && arry.includes("HK")) {
              if (typeof underlyingRic === 'string' && underlyingRic.trim() && underlyingRic.trim().toLowerCase().endsWith(".hk")) {
                  needModifyBID = true;
              }
          }
          if (!needModifyBID && arry.includes(".O")) {
              if (typeof underlyingRic === 'string' && underlyingRic.trim() && underlyingRic.trim().toLowerCase().endsWith(".o")) {
                  needModifyBID = true;
              }
          }
          if (needModifyBID) {
          
            this.setState({chartdata, isLoadingChart});
            this.setState({needModifyBID: true});
          }else{
            this.setState({needModifyBID: false});
            this.setState({ chartdata, isLoadingChart });
          }
        },(error) => {
          this.setState({ chartdata, isLoadingChart });
        }
      );
  }
  componentDidMount() {
    if (!this.isHome()) {
      if (window.location.href.indexOf('formance') != -1) {
        this.setState({ tabNum: LIVE_MATRIX_TABS.HISTORICAL_PERFORMANCE, title: 'Historical Performance' });
      } else if (window.location.href.indexOf('exposure') != -1) {
        this.setState({ tabNum: LIVE_MATRIX_TABS.EXPOSURE_SIMULATOR, title: 'Exposure simulator' });
      } else if (window.location.href.indexOf('warrantterms') != -1) {
        this.setState({ tabNum: LIVE_MATRIX_TABS.WARRANT_TERMS, title: 'Warrant terms' });
      } else if (window.location.href.indexOf('livematrix') != -1) {
        this.setState({ tabNum: LIVE_MATRIX_TABS.LIVE_MATRIX, title: 'Live matrix' });
      } else {
        this.setState({ tabNum: LIVE_MATRIX_TABS.WARRANT_CALCULATOR, title: 'Warrant calculator' });
      }
      this.onFetchUnderlyingSymbol()
      if (this.props.match.params.ticker) {
        let symbols = null;
        const url = MQSGUtil.getAPIBasePath() + "/LiveMatrixJSON?ric=AEML_tm.SI&mode=0";
        fetch(url)
          .then((res) => res.json())
          .then((result) => {
            if ("symbols" in result) {
              symbols = result.symbols;
              this.setState({ symbols });
              let check = symbols.filter((item) => {
                if (item['security_code'] == this.props.match.params.ticker) {
                  item.label = item.dsply_nmll + " (" + item.security_code + ")";
                  item.value = item.ric;
                  item.ticker = item.security_code;
                  return item
                }
              })
              if (check.length > 0) {
                const initselected = { label: check[0].label, value: check[0].value, future_dsply_name: check[0].future_dsply_name }
                this.onWarrantChange(initselected);
              } else {
                const initselected = this.initSelection(symbols);
                this.onWarrantChange(initselected);
              }
            }

          },
            (error) => {
              this.setState({ symbols, isLoading: false });
            }
          );
      } else {
        this.onFetchSymbol();
      }
    } else {
      this.onFetchSymbol();
    }
  }
  setTab(i) {
    if (i != this.state.tabNum) {
      const arr = ['HistoricalPerformance', 'warrantcalculator', 'livematrix', 'warrantterms', 'exposuresimulator'];
      const arr2 = ['Historical Performance', 'Warrant calculator', 'Live matrix', 'Warrant terms', 'Exposure simulator'];
      this.setState({
        tabNum: i
      }, () => {
        const locationData = window.location.pathname.split('/')
        locationData[2] = arr[this.state.tabNum - 1];
        window.history.replaceState(
          {},
          "",
          locationData.join('/')
        );
      })
    }
  }

  initRedirect(props) {
    const match = MQSGUtil.getData(props, "match", null);
    if (match !== null) {
      const params = MQSGUtil.getData(match, "params", null);
      if (params !== null) {
        const ticker = MQSGUtil.getData(params, "ticker", null);
        if (ticker !== null) {
          this.ticker = ticker.toUpperCase();
        }
      }
    }
  }

  initSelection(symbols) {
    let lastselection = MQSGUtil.getLastSelection(this.page);
    if (this.ticker !== null) {
      lastselection = null;
    }
    let selectedsymbol = null;
    let initsymbol = null;
    if (symbols !== null && Array.isArray(symbols)) {
      symbols.forEach((symbol) => {
        if ("ric" in symbol) {
          if (initsymbol === null) {
            initsymbol = symbol;
          }
          if (lastselection === symbol.ric) {
            selectedsymbol = symbol;
          }
        }
        if ("security_code" in symbol) {
          if (this.ticker === symbol["security_code"]) {
            selectedsymbol = symbol;
          }
        }
      });
    }
    if (selectedsymbol !== null) {
      initsymbol = selectedsymbol;
    }
    if (initsymbol !== null) {
      if ("dsply_nmll" in initsymbol && "security_code" in initsymbol) {
        return {
          label: initsymbol.dsply_nmll + " (" + initsymbol.security_code + ")",
          value: initsymbol.ric,
          future_dsply_name: initsymbol.future_dsply_name,
          security_code: initsymbol.security_code
        };
      }
    }
    this.ticker = null;
    return null;
  }

  onFetchStaticSymbol() {
    let symbols = null;
    const staticData = MQSGUtil.getStaticData("LiveMatrix");
    if ("symbols" in staticData) {
      symbols = staticData.symbols;
      this.setState({ symbols });
      const initselected = this.initSelection(symbols);
      this.onWarrantChange(initselected);
    } else {
      this.setState({ symbols, isLoading: false });
    }
  }

  onFetchSymbol() {
    if (MQSGUtil.isUsingStaticData("LiveMatrix")) {
      this.onFetchStaticSymbol();
      return;
    }

    let symbols = null;
    const url =
      MQSGUtil.getAPIBasePath() + "/LiveMatrixJSON?ric=AEML_tm.SI&mode=0";
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          if ("symbols" in result) {
            symbols = result.symbols;
            this.setState({ symbols });
            const initselected = this.initSelection(symbols);
            this.onWarrantChange(initselected);
          }
        },
        (error) => {
          this.setState({ symbols, isLoading: false });
        }
      );
  }

  onFetchStaticData(ric) {
    const isLoading = false;
    const staticData = MQSGUtil.getStaticData("LiveMatrix");
    if (ric in staticData) {
      let livematrixdata = staticData[ric];
      this.logic = new LivematrixLogic(
        livematrixdata.livematrix,
        livematrixdata.ric_data
      );
      this.setState({ livematrixdata, isLoading });
    } else {
      this.setState({ livematrixdata: null, isLoading });
    }
  }

  onFetchData(ric) {
    if (MQSGUtil.isUsingStaticData("LiveMatrix")) {
      setTimeout(() => {
        this.onFetchStaticData(ric);
      }, 100); // pretend fetch
      return;
    }
    const isLoading = false;
    const url = MQSGUtil.getAPIBasePath() + "/LiveMatrixJSON?ric=" + ric + "&mode=0";
    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          let finalResult = MQSGUtil.filterDataLiveMatrixJSON(result);
          const livematrixdata = finalResult;
          this.setState({messageList:livematrixdata?.['message'] || []})
          if (livematrixdata?.livematrix && livematrixdata?.ric_data) {
            this.logic = new LivematrixLogic(
              livematrixdata.livematrix,
              livematrixdata.ric_data
            );
          }
          this.setState({ livematrixdata, isLoading }, () => {
            const underlyingric = this.state.livematrixdata?.ric_data?.underlying_ric;
            const underlying_ticker = this.state.livematrixdata?.ric_data?.underlying_ticker;
            this.onFetchChartData(
              underlyingric,
              ric,
              this.state.period
            );
            if (underlying_ticker === "HSI" || underlying_ticker === "N225" || underlying_ticker === "HSTECH" || underlying_ticker === "SiMSCI" || underlying_ticker === "S&P500") {
              this.refreshIndex(underlying_ticker)
            } else {
              this.setState({ showHSILiveIndex: false, showNKYLiveIndex: false, showHSTECHLiveIndex: false, showSIMSCILiveIndex: false, showSP500LiveIndex: false })
            }
            if (underlying_ticker && underlying_ticker.length > 0) {
              this.setState({ displayMorningMarketBuzz: true })
              this.getMorningMarketBuzzTile(underlying_ticker)
            }
          });
        },
        (error) => {
          this.setState({ livematrixdata: null, isLoading });
        }
      );
  }

  onWarrantChange(selected) {
    if (selected !== undefined && selected !== null) {
      MQSGUtil.updateLastView(selected.value);
      this.logic = null; // hide previous data
      this.setState({ selected, livematrixdata: null, isLoading: true });
      this.onFetchData(selected.value);

      MQSGUtil.updateLastSelection(this.page, selected.value);
      const lastviewrics = MQSGUtil.updateLastView(selected.value);
      this.setState({ lastviewrics });
    }
  }

  onRefresh() {
    this.onWarrantChange(this.state.selected);
  }

  getSymbols() {
    if (this.state.symbols !== null) {
      if (Array.isArray(this.state.symbols)) {
        return this.state.symbols;
      }
    }
    return null;
  }

  getSelectedLabel() {
    if (this.state.selected === null) {
      return "";
    }
    return this.state.selected.label;
  }

  isLoading() {
    return this.state.isLoading;
  }

  isHome() {
    if (this.props.page !== undefined && this.props.page !== null) {
      if (this.props.page === "home") {
        return true;
      }
    }
    return false;
  }

  renderHome() {
    let isShow = true;
    let isSti = false;
    if (this.logic != null) {
      if (this.logic.isSTI) {
        isSti = true;
      } else {
        isSti = false;
      }
    }
    if (
      this.state.livematrixdata == null ||
      !this.state.livematrixdata?.livematrix ||
      this.state.livematrixdata.livematrix.length === 0 ||
      isSti
    ) {
      isShow = false;
    }
    let code = '';
    if (this.state.selected != null) {
      code = this.state.selected.label.slice(this.state.selected.label.indexOf('(') + 1, this.state.selected.label.indexOf(')'))
    }
    return (
      <div className="holder-lmatrix" >
        <div id="lmatrix">
          <div className="page-header">
            <h2 className="small">Live matrix</h2>
          </div>
          <p className="section-p">
            Shows investors where our bid and offer prices are for a range of
            given underlying prices.
          </p>
        </div>
        <div>
          <Warrant
            symbols={this.getSymbols()}
            disabled={this.isLoading()}
            isHome={this.isHome()}
            onWarrantChange={(selected) => this.onWarrantChange(selected)}
          />
        </div>
        <div
          className="ricbar-home bgcolor-03"
          style={{
            // display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
            marginTop: "10px",
            display: !isShow ? "none" : "flex",
            overflowX: 'auto'
          }}
        >
          <div
            className="ticker-home"
            id="ticker"
            style={{ paddingLeft: "10px", lineHeight: '35px' }}
          >
            {this.getSelectedLabel()}
          </div>
          <a href={"/tools/livematrix/" + code} style={{ display: "flex", alignItems: 'center' }} target="_blank">
            <p style={{ margin: "4px", lineHeight: "25px" }}>View more</p>
            <img src="/img/bullet/qlink-achor.png" alt="" style={{ height: 36, width: 36 }} />
          </a>
        </div>
        <div
          style={{
            display: isShow || !isSti ? "none" : "block",
            marginTop: "10px",
            fontStyle: "italic",
          }}
        >
          Please select a warrant to see its live matrix.
        </div>
        <LiveMatrixTodayTable date={this.state.livematrixdata?.last_update} symbols={this.state.symbols} messageList={this.state.messageList} logic={this.logic} page={this.props.page} isLoading={this.state.isLoading} />
      </div>
    );
  }
  childMethod() {
    if (this.refs.child) {
      this.refs.child.onClickTradeWarrantsHere()
    }
  }
  getUpDownClass(value) {
    if (value < 0) {
      return "down";
    } else if (value > 0) {
      return "up";
    }
  }

  formatLiveIndexTime(stime) {
    if (!stime) return null;
    const date = new Date(stime);
    let hours = date.getHours() + 1;
    let min = date.getMinutes();
    const today = new Date();
    let s = today.getSeconds();
    if (s < 10) {
      s = "0" + s;
    }
    hours = hours - 2;
    let ampm = "AM";
    if (hours > 11) {
      ampm = "PM";
    }
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (min < 10) {
      min = "0" + min;
    }
    return `${hours}:${min}:${s} ${ampm}`;
  }

  formatNumber(num) {
    if (num === null || num === undefined) return null;
    const output = new Intl.NumberFormat();
    return output.format(num);
  }

  formatChange(value, isPercent = false) {
    if (value === null || value === undefined) return null;
    let formatted = isPercent ? String(value).replace('%', '') : String(value);
    const numValue = parseFloat(formatted);
    if (isNaN(numValue)) return null;
    if (numValue > 0) {
      return "+" + numValue;
    }
    return String(numValue);
  }

  runLiveHSI() {
    const url = MQSGUtil.getAPIBasePath() + "/LiveIndexJSON?ric=HSI";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.code) {
          // 将数据存储在 state 中，让 React 来渲染
          this.setState({
            hsiData: {
              code: data.code.toString().toUpperCase(),
              month: data.month,
              last: data.last,
              chng: data.chng,
              pchng: data.pchng,
              stime: data.stime
            }
          });
        }
      })
      .catch(error => console.error(error));
  };

  runLiveHSTECH() {
    const url = MQSGUtil.getAPIBasePath() + "/LiveIndexJSON?ric=HTI";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.code) {
          // 将数据存储在 state 中，让 React 来渲染
          this.setState({
            hstechData: {
              code: data.code.toString().toUpperCase(),
              month: data.month,
              last: data.last,
              chng: data.chng,
              pchng: data.pchng,
              stime: data.stime
            }
          });
        }
      })
      .catch(error => console.error(error));
  };

  runLiveNKY() {
    const url = MQSGUtil.getAPIBasePath() + "/LiveIndexJSON?ric=N225";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const update_time = MQSGUtil.getData(data, "update_time");
        let source = data?.["SSIcv1"]?.[0] || data?.["SSIcv2"]?.[0];
        if (source) {
          // 将数据存储在 state 中，让 React 来渲染
          this.setState({
            nkyData: {
              expiryMonth: MQSGUtil.getData(source, "expiryMonth"),
              bid: MQSGUtil.getData(source, "bid"),
              net: MQSGUtil.getData(source, "net"),
              pct: MQSGUtil.getData(source, "pct"),
              update_time: update_time
            }
          });
        }
      })
      .catch(error => console.error(error));
  }

  runLiveSIMSCI() {
    const url = MQSGUtil.getAPIBasePath() + "/LiveIndexJSON?ric=SIMSCI";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let source = (data?.SSGc1 || data?.SSGc2)?.[0];
        if (source) {
          const update_time = MQSGUtil.getData(data, "update_time");
          // 将数据存储在 state 中，让 React 来渲染
          this.setState({
            simsciData: {
              expiryMonth: MQSGUtil.getData(source, "expiryMonth"),
              bid: MQSGUtil.getData(source, "bid"),
              net: MQSGUtil.getData(source, "net"),
              pct: MQSGUtil.getData(source, "pct"),
              update_time: update_time
            }
          });
        }
      })
      .catch(error => console.error(error));
  }

  runLiveSP500() {
    const url = MQSGUtil.getAPIBasePath() + "/LiveIndexJSON?ric=S%26P500";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const update_time = MQSGUtil.getData(data, "update_time");
        let source = data?.["SSIcv1"]?.[0] || data?.["SSIcv2"]?.[0];
        if (source) {
          // 将数据存储在 state 中，让 React 来渲染
          this.setState({
            sp500Data: {
              expiryMonth: MQSGUtil.getData(source, "expiryMonth"),
              bid: MQSGUtil.getData(source, "bid"),
              net: MQSGUtil.getData(source, "net"),
              pct: MQSGUtil.getData(source, "pct"),
              update_time: update_time
            }
          });
        }
      })
      .catch(error => console.error(error));
  };

  getMorningMarketBuzzTile(underlying) {
    try {
      const url = MQSGUtil.getAPIBasePath() + `/NewsTableServlet?sp=todayhighlight&start=0&underlying=${underlying.replace('&', '%26')}`;
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          let news = data?.newsList;
          if (news && news.length > 0 && news[0]?.en_title) {
            this.setState({ latestNewTitle: news[0].en_title, latestNewUnderlying: underlying })
          }
        })
    } catch (error) {
      console.error(error)
    }
  }

  refreshIndex(arg) {
    if (arg === "HSI") {
      this.setState({ showHSILiveIndex: true, showNKYLiveIndex: false, showHSTECHLiveIndex: false, showSIMSCILiveIndex: false, showSP500LiveIndex: false })
      this.runLiveHSI();
    } else if (arg === "NKY" || arg === "N225") {
      this.setState({ showHSILiveIndex: false, showNKYLiveIndex: true, showHSTECHLiveIndex: false, showSIMSCILiveIndex: false, showSP500LiveIndex: false })
      this.runLiveNKY();
    } else if (arg === "HSTECH") {
      this.setState({ showHSILiveIndex: false, showNKYLiveIndex: false, showHSTECHLiveIndex: true, showSIMSCILiveIndex: false, showSP500LiveIndex: false })
      this.runLiveHSTECH();
    } else if (arg === "SiMSCI") {
      this.setState({ showHSILiveIndex: false, showNKYLiveIndex: false, showHSTECHLiveIndex: false, showSIMSCILiveIndex: true, showSP500LiveIndex: false })
      this.runLiveSIMSCI()
    } else if (arg === "S&P500") {
      this.setState({ showHSILiveIndex: false, showNKYLiveIndex: false, showHSTECHLiveIndex: false, showSIMSCILiveIndex: false, showSP500LiveIndex: true })
      this.runLiveSP500()
    } else {
      this.setState({ showHSILiveIndex: false, showNKYLiveIndex: false, showHSTECHLiveIndex: false, showSIMSCILiveIndex: false, showSP500LiveIndex: false })
    }
  }

  renderPage() {
    let ric = null;
    let isWarrantsShow = false;
    let isUnderyingShow = false;
    let future_dsply_name = '';
    if (
      typeof this.state.selected !== "undefined" &&
      this.state.selected !== null
    ) {
      ric = this.state.selected.value;
      name = this.state.selected.label;
      if (
        this.state.selected.label.indexOf('S&P') != -1 ||
        this.state.selected.label.indexOf('DJI') != -1 ||
        this.state.selected.label.indexOf('HSI') != -1 ||
        this.state.selected.label.indexOf('HSTECH') != -1 ||
        this.state.selected.label.indexOf('NKY') != -1 ||
        this.state.selected.label.indexOf('SiMSCI') != -1 ||
        this.state.selected.label.indexOf('Sea') != -1 ||
        this.state.selected.label.indexOf('NASDAQ') != -1
      ) {
        isWarrantsShow = true;
      } else {
        if (this.state.selected.future_dsply_name && this.state.selected.future_dsply_name != '' && this.state.selected.future_dsply_name != '-') {
          isUnderyingShow = true;
          future_dsply_name = this.state.selected.future_dsply_name;
        }
      }
    }
    return (
      <div id="livematrix" className="pageobj" onClick={() => this.childMethod()}>
        <BreadcrumbBar
          link="/home"
          group="Warrant tools"
          title={this.state.title}
        />
        <div className="stripe-bg"></div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="section">
                <PageHeader title={this.state.title} ref="child" />
                {
                  this.state.title == 'Live matrix' ? (
                    <div>
                      <div>
                        Shows investors where our bid and offer prices are for a range
                        of given underlying prices.{" "}
                        <span
                          className="ttip"
                          data-target="livematrixdescription"
                          data-hasqtip="0"
                          data-tip
                          data-for="indicator-hotdw-tooltip"
                          data-tooltip-id="indicator-hotdw-tooltip"
                        >
                          <mark>
                            Read on to find out how the matrix for put warrants differ
                            from calls
                          </mark>
                          <ReactTooltip
                            id="indicator-hotdw-tooltip"
                            delayHide={100}
                            place="right"
                            type="warning"
                            effect="solid"
                            backgroundColor="#FECC0A"
                            textColor="#000"
                            className="ttip_con"
                          >
                            <div
                              style={{
                                color: "#333333",
                              }}
                            >
                              Put prices move in the opposite direction to the share
                              price, for this reason the price matrices
                              <br />
                              are the opposite to what you would find for a call
                              warrant, where..
                              <br />
                              The{" "}
                              <span style={{ textDecoration: "underline" }}>
                                offer
                              </span>{" "}
                              price for the warrant is based on the bid price of the
                              underlying
                              <br />
                              The{" "}
                              <span style={{ textDecoration: "underline" }}>
                                bid{" "}
                              </span>
                              price for the warrant is based on the offer price of the
                              underlying
                            </div>
                          </ReactTooltip>
                        </span>
                      </div>
                      <p style={{ marginTop: "10px" }}>
                        The live matrix consists of a table showing a range of prices for the underlying’s bid/offer and warrant’s bid/offer.
                      </p>
                      <p style={{ marginTop: "10px" }}>
                        Call prices move in the same direction as the share price. The call warrant offer price is based on the underlying offer price while the bid price of the warrant is based on the underlying bid price.
                      </p>
                      <p style={{ marginTop: "10px" }}>
                        On the other hand, the offer price for a put warrant is based on the bid price of the underlying while the bid price for the warrant is based on the offer price of the underlying"
                      </p>
                    </div>) : this.state.title == 'Historical Performance' ? (
                      <p>
                        See the historical performance for individual warrants.
                      </p>
                    ) : this.state.title == 'Warrant calculator' ? (
                      <p>
                        Estimates the theoretical price of a warrant based on your
                        input of the underlying price, date or implied volatility.
                      </p>
                    ) : this.state.title == 'Warrant terms' ? (
                      <p>
                        Everything you need to know about your selected warrant is found here.
                      </p>
                    ) : (
                    <p>
                      A tool to help you estimate your warrant investment amount either to replicate an equivalent level of exposure to a stock or to hedge your current stockholding.
                    </p>
                  )
                }
                <div id="top_area">
                  <Underlying
                    underlying={this.state.underlying}
                    onUnderlyingChange={(option) =>
                      this.onUnderlyingChange(option)
                    }
                    onMenuOpen={()=>
                      this.onMenuOpen()
                    }
                  />
                  <p style={{ margin: '15px 0px' }}></p>
                  <Warrant
                    ref={this.setWarrantRef}
                    symbols={this.getSymbols()}
                    disabled={this.isLoading()}
                    onWarrantChange={(selected) =>
                      this.onWarrantChange(selected)
                    }
                  />

                  <div className="tablist">
                    <div id="topTabs" className="tablist-left" style={{ overflowX: 'auto' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td
                              className={classNames({
                                active: this.state.tabNum == 1,
                              })}
                              onClick={() => this.setTab(1)}
                            >
                              <div className="tablist-item">
                                <div className="tablist-item-txt">
                                  Historical Performance
                                </div>
                              </div>
                            </td>
                            <td
                              className={classNames({
                                active: this.state.tabNum == 4,
                              })}
                              onClick={() => this.setTab(4)}
                            >
                              <div className="tablist-item">
                                <div className="tablist-item-txt">
                                  Warrant terms
                                </div>
                              </div>
                            </td>
                            <td
                              className={classNames({
                                active: this.state.tabNum == 2,
                              })}
                              onClick={() => this.setTab(2)}
                            >
                              <div className="tablist-item">
                                <div className="tablist-item-txt">
                                  Warrant Calculator
                                </div>
                              </div>
                            </td>
                            <td
                              className={classNames({
                                active: this.state.tabNum == 3,
                              })}
                              onClick={() => this.setTab(3)}
                            >
                              <div className="tablist-item">
                                <div className="tablist-item-txt">
                                  Live matrix
                                </div>
                              </div>
                            </td>
                            <td
                              className={classNames({
                                active: this.state.tabNum == 5,
                              })}
                              onClick={() => this.setTab(5)}
                            >
                              <div className="tablist-item">
                                <div className="tablist-item-txt">
                                  Exposure simulator
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {
                    this.state.tabNum == 3 ? <LiveMatrixTodayTable date={this.state.livematrixdata?.last_update} symbols={this.state.symbols} messageList={this.state.messageList} logic={this.logic} isLoading={this.state.isLoading} selected={this.state.selected} /> : this.state.tabNum == 4 ? <IndtableShow
                      warrantdata={this.state.livematrixdata && this.state.livematrixdata.ric_data}
                    /> : null
                  }

                  <div style={{ display: this.state.tabNum == 1 ? 'block' : 'none' }}>
                    <TermsChart
                      selected={this.state.selected}
                      period={this.state.period}
                      needModifyBID={this.state.needModifyBID}
                      chartdata={this.state.chartdata}
                      onPeriodChange={this.onPeriodChange.bind(this)}
                      warrantdata={this.state.livematrixdata && this.state.livematrixdata.ric_data}
                    />
                  </div>
                  {
                    this.state.tabNum === 2 && this.state.livematrixdata != null && <WrCalculatorBox needModifyBID={this.state.needModifyBID} isRightPanel={true} ric={ric} marketdata={this.state.livematrixdata?.ric_data} iv={this.state.livematrixdata?.iv} />
                  }
                  {
                    this.state.tabNum == 5 && this.state.livematrixdata != null && <WarrantHedget
                      warrantdata={this.state.livematrixdata.ric_data}
                    />
                  }
                </div>

              </div>
            </div>
            <div className="hidden-xs hidden-sm col-md-4">
              {/* <LiveIndexFuture liveMatrix={true} isSti={this.state.selected} /> */}
              <AdvertBox />
              <div id="qlink-dwvideo" className="holder-qlink-dwvideo ">
                <div className="videoplayer">
                  <div className="videoplayer-container">
                    <iframe
                      title="education video"
                      frameBorder="0"
                      allowFullScreen=""
                      className="dwvideo-iframe"
                      src="https://www.youtube.com/embed/_EqFjoCgE08?autoplay=0&index=0&rel=0&wmode=opaque"
                    ></iframe>
                  </div>
                </div>
              </div>
              <div className="col-md-14 hidden-xs hidden-sm">
                <LastView lastviewrics={this.state.lastviewrics} />
                <div className="his-index">
                  <div className="holder-indexfuture1" style={{ display:  this.state.showNKYLiveIndex ||  this.state.showSIMSCILiveIndex ? "" : "none" }}>
                    <div
                      id="indexfuture"
                      className="section qlink-section"
                      style={{minHeight:'auto'}}
                    >
                      <div className="page-header">
                        <h1 className="small">Live index futures</h1>
                      </div>
                      <table className="table table-striped table-noHeaderborder">
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Contract</th>
                            <th>Last</th>
                            <th>Change</th>
                            <th>Change%</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="row_HSI" style={{ display: this.state.showHSILiveIndex ? "" : "none" }}>
                            <td style={{ padding: "2px" }}>
                              <Link to="/tools/underlying/HSI">HSI*</Link>
                            </td>
                            <td className="col_month" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td className="col_last" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td
                              className="col_chng val up"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td
                              className="col_pchng val up"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td style={{ padding: "2px" }}>
                              <img
                                className="refresh_index"
                                style={{
                                  cursor: "pointer",
                                  width: "30px",
                                  margin: "4px 0",
                                }}
                                onClick={() => this.refreshIndex("HSI")}
                                src="/img/bullet/refresh.png"
                              />
                            </td>
                          </tr>
                          <tr className="row_NKY" style={{ display: this.state.showNKYLiveIndex ? "" : "none" }}>
                            <td style={{ padding: "2px" }}>
                              <Link to="/tools/underlying/N225">Nikkei</Link>
                            </td>
                            <td className="col_month" style={{ padding: "2px" }}>
                              {this.state.nkyData?.expiryMonth || "-"}
                            </td>
                            <td className="col_last" style={{ padding: "2px" }}>
                              {this.state.nkyData?.bid || "-"}
                            </td>
                            <td
                              className={"col_chng val" + (this.state.nkyData?.net && Number(this.state.nkyData.net.toString().replace(/,/g, "")) > 0 ? " up" : " down")}
                              style={{ padding: "2px" }}
                            >
                              {MQSGUtil.formatNumberDisplay(this.state.nkyData?.net, 2)}
                            </td>
                            <td
                              className={"col_pchng val" + (this.state.nkyData?.pct && Number(this.state.nkyData.pct.toString().replace(/,/g, "")) > 0 ? " up" : " down")}
                              style={{ padding: "2px" }}
                            >
                              {MQSGUtil.formatNumberDisplay(this.state.nkyData?.pct, 2)}
                            </td>
                            <td style={{ padding: "2px" }}>
                              <img
                                onClick={() => this.refreshIndex("NKY")}
                                className="refresh_index"
                                style={{ cursor: "pointer", width: "22px" }}
                                src="/img/bullet/refresh.png"
                              />
                            </td>
                          </tr>
                          <tr className="row_HSTECH" style={{ display: this.state.showHSTECHLiveIndex ? "" : "none" }}>
                            <td style={{ padding: "2px" }}>
                              <Link to="/tools/underlying/HSTECH">HSTECH*</Link>
                            </td>
                            <td className="col_month" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td className="col_last" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td
                              className="col_chng val"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td
                              className="col_pchng val"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td style={{ padding: "2px" }}>
                              <img
                                className="refresh_index"
                                style={{ cursor: "pointer", width: "22px" }}
                                src="/img/bullet/refresh.png"
                                onClick={() => this.refreshIndex("HSTECH")}
                              />
                            </td>
                          </tr>
                          <tr className="row_SIMSCI" style={{ display: this.state.showSIMSCILiveIndex ? "" : "none" }}>
                            <td style={{ padding: "2px" }}>
                              <Link to="/tools/underlying/SIMSCI">SIMSCI*</Link>
                            </td>
                            <td className="col_month" style={{ padding: "2px" }}>
                              {this.state.simsciData?.expiryMonth || "-"}
                            </td>
                            <td className="col_last" style={{ padding: "2px" }}>
                              {MQSGUtil.formatNumberDisplay(this.state.simsciData?.bid, 2)}
                            </td>
                            <td
                              className={"col_chng val" + (this.state.simsciData?.net > 0 ? " up" : " down")}
                              style={{ padding: "2px" }}
                            >
                              {MQSGUtil.formatNumberDisplay(this.state.simsciData?.net, 2)}
                            </td>
                            <td
                              className={"col_pchng val" + (this.state.simsciData?.pct > 0 ? " up" : " down")}
                              style={{ padding: "2px" }}
                            >
                              {MQSGUtil.formatNumberDisplay(this.state.simsciData?.pct, 2)}
                            </td>
                            <td style={{ padding: "2px" }}>
                              <img
                                className="refresh_index"
                                style={{ cursor: "pointer", width: "22px" }}
                                src="/img/bullet/refresh.png"
                                onClick={() => this.refreshIndex("SiMSCI")}
                              />
                            </td>
                          </tr>
                          <tr className="row_SP500" style={{ display: this.state.showSP500LiveIndex ? "" : "none" }}>
                            <td style={{ padding: "2px" }}>
                              <Link to="/tools/underlying/SP500">S&P500</Link>
                            </td>
                            <td className="col_month" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td className="col_last" style={{ padding: "2px" }}>
                              -
                            </td>
                            <td
                              className="col_chng val"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td
                              className="col_pchng val"
                              style={{ padding: "2px" }}
                            >
                              -
                            </td>
                            <td style={{ padding: "2px" }}>
                              <img
                                onClick={() => this.refreshIndex("S&P500")}
                                className="refresh_index"
                                style={{ cursor: "pointer", width: "22px" }}
                                src="/img/bullet/refresh.png"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    
                    </div>
                  </div>
                </div>
                <div id="dailyhighlights" className="section qlink-section" style={{ display: this.state.displayMorningMarketBuzz ? "" : "none" }}>
                  <div className="page-header">
                    <h1 className="small">Morning Market Buzz</h1>
                  </div>
                  <div className="news-title" >
                    {this.state.latestNewTitle}
                  </div>
                  <div style={{ textAlign: "right", marginRight: "20px" }}>
                    <Link to={"/marketnews/dailyhighlights/" + this.state.latestNewUnderlying} target="_blank">
                      <img src="/img/bullet/qlink-achor.png" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </div >
    );
  }

  render() {
    if (this.isHome()) {
      return this.renderHome();
    } else {
      return this.renderPage();
    }
  }
}

class Warrant extends Component {
  onChange(selected) {
    let name = selected.label.slice(selected.label.indexOf('(') + 1, selected.label.indexOf(')'))
    if (this.props.isHome) {
      this.props.onWarrantChange(selected);
    } else {
      const locationData = window.location.pathname.split('/')
      window.history.replaceState(
        {},
        "",
        `/tools/${locationData[2]}/${name}`
      );
      this.props.onWarrantChange(selected);
    }
  }
  getDisplayName() {
    const symbols = [];
    if (this.props.symbols !== null && this.props.symbols.length > 0) {
      this.props.symbols.forEach((element) => {
        if (
          "ric" in element &&
          "dsply_nmll" in element &&
          "security_code" in element
        ) {
          const item = {
            label: element.dsply_nmll + " (" + element.security_code + ")  " + MQSGUtil.wrrantCurrency(element) + element.exercise_price,
            value: element.ric,
            future_dsply_name: element.future_dsply_name
          };
          symbols.push(item);
        }
      });
    }
    return symbols;
  }
  onMenuOpen() {
    if (this.warrantRef) {
      this.warrantRef.onMenuOpen()
    }
  }
  closeDropdown = () => {
   if (this.warrantRef) {
     this.warrantRef.onMenuClose()
   }
  };
  filterOption(candidate, input) {
    return createFilter()(candidate, input);
  };
  render() {
    return (
      <div id="dropdown-warrant">
        <div>
          <Select
            className="center"
            placeholder="Select warrant"
            options={this.getDisplayName()}
            onChange={this.onChange.bind(this)}
            isDisabled={this.props.disabled}
            ref={this.setWarrantRef}
            styles={{
              option: (provided, state) => ({
                ...provided,
                textAlign: "center",
                ':hover': {
                  backgroundColor: '#1A73E8',
                }
              }),
              valueContainer: (provided) => ({
                ...provided,
                justifyContent: 'center'
              })
            }}
            filterOption={this.filterOption}
         
          />
        </div>
      </div>
    );
  }
}
class Underlying extends React.Component {
  constructor(props) {
    super(props);
    this.underlyingOption = null;
  }

  onChange(selected) {
    this.props.onUnderlyingChange(selected);
  }
  onMenuOpen(){
    this.props.onMenuOpen();
  }
  getUnderlyingOption() {
    if (this.underlyingOption === null) {
      if (this.props.underlying !== null && "symbols" in this.props.underlying) {
        this.underlyingOption = MQSGUtil.getUnderlyingOption(this.props.underlying["symbols"]);
      }
    }
    return this.underlyingOption;
  }
filterOption(candidate, input) {
    const symbols = this.props.underlying?.["symbols"] || null;
    return MQSGUtil.filterOption(symbols, candidate, input);
  }

  render() {
    return (
      <div id="dropdown-underlying">
        <div>
          <Select
           onMenuOpen={this.onMenuOpen.bind(this)}
            placeholder="Select underlying"
            options={this.getUnderlyingOption()}
            onChange={this.onChange.bind(this)}
            filterOption={this.filterOption.bind(this)}
            className="center"
            formatOptionLabel={(data) => {
              const handleMouseEnter = (e) => {
                const span = e.currentTarget.querySelector('.symbol-span');
                if (span) {
                  const parentElement = e.currentTarget.parentElement.parentElement.parentElement;
                  if (parentElement) {
                    const parentClass = parentElement.className;
                    if(parentClass.trim().toLowerCase().includes('menu')){
                      span.style.color = "#fdfdfd";
                    }
                  }
                }
              };
              const handleMouseLeave = (e) => {
                const span = e.currentTarget.querySelector('.symbol-span');
                if (span) {
                  const parentElement = e.currentTarget.parentElement.parentElement.parentElement;
                  if (parentElement) {
                    const parentClass = parentElement.className;
                    if(parentClass.trim().toLowerCase().includes('menu')){
                      span.style.color = "#0675C2";
                    }
                  }
                }
              };
              const isPriceZero = Number(data.TRDPRC_1) === 0;
              return (
                <div
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  key={data.symbol}
                  className="selectSption"
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    padding: '5px 0px',
                  }}
                >
                  <span className="symbol-span" style={{ color: "#0675C2" }} >{data.symbol} </span>
                  {!isPriceZero && (
                    <span>
                      {MQSGUtil.currency(data)}
                      {MQSGUtil.formatNumberDisplay(data.TRDPRC_1)}{" "}
                    </span>
                  )}
                  <span
                    style={{
                      color: data["PCTCHNG"] > 0 ? "#6CC263" : "red",
                    }}
                  >
                    (
                    {data.PCTCHNG > 0 ? "+" + MQSGUtil.formatNumberDisplay(data.PCTCHNG) : MQSGUtil.formatNumberDisplay(data.PCTCHNG)}%)
                  </span>
                </div>
              );
            }}
            isSearchable={true}
            styles={{
              option: (provided, state) => ({
                ...provided,
                cursor: 'pointer',
                backgroundColor: '#FFFFFF',
                padding: '0',
                color: '#000',
                ':hover': {
                  backgroundColor: '#1A73E8',
                },
              }),
              valueContainer: (provided) => ({
                ...provided,
                justifyContent: 'center',
              })
            }}
          />
        </div>
      </div>
    );
  }
}
class TableGeneral extends Component {
  getData(fieldName, dp = null) {
    if (
      this.props.warrantdata !== null &&
      fieldName in this.props.warrantdata
    ) {
      const value = this.props.warrantdata[fieldName];
      if (dp !== null) {
        return Number(value).toFixed(dp);
      }
      return value;
    }
    return "";
  }

  getTheta() {
    // "last_trading_date": "23 Feb 21"
    const lasttradingdate = this.getData("last_trading_date");
    const currDate = new Date();
    const currDateMS = currDate.getTime();
    if (lasttradingdate.length > 0) {
      const lasttradingdateMS = Date.parse(lasttradingdate);
      const diff = currDateMS - lasttradingdateMS;
      // check if expired
      if (diff <= 24 * 60 * 60 * 1000) {
        return this.getData("theta", 4);
      }
    }
    return "-";
  }

  getMoneynessClass(nc) {
    let cnm = "";
    const value = Number(nc);
    if (!isNaN(value)) {
      if (value === 1) {
        cnm = "val mny up";
      } else if (value === 2) {
        cnm = "val mny down";
      }
    }
    return cnm;
  }

  getMoneynessName(nc) {
    let nm = "";
    const value = Number(nc);
    if (!isNaN(value)) {
      if (value === 1) {
        return "ITM";
      } else if (value === 2) {
        return "OTM";
      } else {
        return "ATM";
      }
    }
    return nm;
  }

  render() {
    const hstclose = this.getData("HST_CLOSE");
    const trdprc1 = this.getData("TRDPRC_1");
    const openprc = this.getData("OPEN_PRC");
    const acvol1scaled = this.getData("ACVOL_1_SCALED");
    const high1 = this.getData("HIGH_1");
    const turnoverscaled = this.getData("TURNOVER_SCALED");
    const low1 = this.getData("LOW_1");
    const underlyingprice = this.getData("underlying_price");
    const ticker = this.getData("ticker");
    const effectivegearing = this.getData("effective_gearing");
    const underlyingticker = this.getData("underlying_ticker");
    const delta = this.getData("delta");
    const type = this.getData("type");
    const deltaperwrnt = this.getData("delta_per_wrnt");
    const issuername = this.getData("issuer_name");
    const sensitivity = this.getData("sensitivity");
    const exerciseprice = this.getData("exercise_price");
    const breakevenprice = this.getData("breakeven_price");
    const tradedate = this.getData("TRADE_DATE");
    const premium = this.getData("premium");
    const maturity = this.getData("maturity");
    const impliedvolatility = this.getData("implied_volatility");
    const lasttradingdate = this.getData("last_trading_date");
    const theta = this.getTheta();
    const daystomaturity = this.getData("days_to_maturity") + " days";
    const intrinsicvalue = this.getData("intrinsic_value");
    const convratio = this.getData("conv_ratio");
    const moneyness = this.getData("moneyness");
    const moneynessClass = this.getMoneynessClass(moneyness);
    const moneynessdisplaystring =
      this.getData("percent_moneyness") +
      "% " +
      this.getMoneynessName(moneyness);

    return (
      <div>
        <div id="srtable" style={{ position: "relative" }}>
          <table className="table priorTable">
            <tbody>
              <tr>
                <th
                  className="srtable-leftlbl bgcolor-01"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  Prior
                </th>
                <td
                  className="srtable-leftval bgcolor-01 val HST_CLOSE"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(hstclose, 3)}
                </td>
                <th
                  className="srtable-rightlbl bgcolor-02"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  Last trade
                </th>
                <td
                  className="srtable-rightval bgcolor-02 val TRDPRC_1"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(trdprc1, 3)}
                </td>
              </tr>
              <tr>
                <th className="srtable-leftlbl" style={{ border: 0, textAlign: 'left' }}>
                  Open
                </th>
                <td
                  className="srtable-leftval val OPEN_PRC"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(openprc, 3)}
                </td>
                <th className="srtable-rightlbl" style={{ border: 0, textAlign: 'left' }}>
                  Traded volume ('000)
                </th>
                <td className="srtable-rightval val ACVOL_1_SCALED" style={{ textAlign: 'left' }}>
                  {MQSGUtil.formatNumberDisplay(acvol1scaled)}
                </td>
              </tr>
              <tr>
                <th
                  className="srtable-leftlbl bgcolor-01"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  High
                </th>
                <td
                  className="srtable-leftval bgcolor-01 val HIGH_1"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(high1, 3)}
                </td>
                <th
                  className="srtable-rightlbl bgcolor-02"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  Traded value ('000 SGD)
                </th>
                <td
                  className="srtable-rightval bgcolor-02 val TURNOVER_SCALED"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(turnoverscaled)}
                </td>
              </tr>
              <tr>
                <th className="srtable-leftlbl" style={{ textAlign: 'left' }}>Low</th>
                <td className="srtable-leftval val LOW_1" style={{ border: 0, textAlign: 'left' }}>
                  {MQSGUtil.formatNumberDisplay(low1, 3)}
                </td>
                <th className="srtable-rightlbl" style={{ border: 0, textAlign: 'left' }}>
                  Underlying price
                </th>
                <td
                  className="srtable-rightval val underlying_price"
                  style={{ border: 0, textAlign: 'left' }}
                >
                  {MQSGUtil.formatNumberDisplay(underlyingprice, 3)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}